var _path, _path2, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 16.875C32.5 11.6973 28.3027 7.5 23.125 7.5H22.8125C17.8074 7.5 13.75 11.5574 13.75 16.5625C13.75 21.5676 17.8074 25.625 22.8125 25.625H32.5V16.875Z",
    stroke: "white",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 22C6.625 16.27 11.27 11.625 17 11.625C22.73 11.625 27.375 16.27 27.375 22C27.375 27.73 22.73 32.375 17 32.375H6.625V22Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 21,
    x2: 22,
    y2: 21,
    stroke: "#1A1B1D",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 25,
    x2: 22,
    y2: 25,
    stroke: "#1A1B1D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconWhite);
export default __webpack_public_path__ + "static/media/chat-icon-white.82751cbaa3c6037026e79898c62e4858.svg";
export { ForwardRef as ReactComponent };